import { StoreModuleItem, StripePriceRecurringInterval } from '@/lib/service/pietra-v2';
import { BillingOption } from '../types/subscription';
import { BasisPointUtil } from './basis-point.util';
import { find } from 'lodash-es';

export const findPriceForSelectedInterval = (module: StoreModuleItem, billingOption: BillingOption) => {
  return find(module?.prices, (price) => {
    switch (billingOption) {
      case BillingOption.MONTH:
        return (
          price.isEnabled &&
          price.recurringInterval === StripePriceRecurringInterval.Month &&
          price.recurringIntervalCount === 1
        );
      case BillingOption.QUARTERLY:
        return (
          price.isEnabled &&
          price.recurringInterval === StripePriceRecurringInterval.Month &&
          price.recurringIntervalCount === 3
        );
      case BillingOption.YEAR:
        return (
          price.isEnabled &&
          price.recurringInterval === StripePriceRecurringInterval.Year &&
          price.recurringIntervalCount === 1
        );
      default:
        return false;
    }
  });
};

export const getMonthlyPriceForModule = (module: StoreModuleItem, billingOption: BillingOption) => {
  const price = findPriceForSelectedInterval(module, billingOption);
  let monthlyPrice = 0;
  switch (billingOption) {
    case BillingOption.MONTH: {
      monthlyPrice = price?.priceBp;
      break;
    }
    case BillingOption.QUARTERLY: {
      monthlyPrice = price?.priceBp / 3;
      break;
    }
    case BillingOption.YEAR: {
      monthlyPrice = price?.priceBp / 12;
      break;
    }
    default:
      break;
  }
  return BasisPointUtil.bpToNum(monthlyPrice);
};

export const getPriceForModule = (module: StoreModuleItem, billingOption: BillingOption) => {
  const price = findPriceForSelectedInterval(module, billingOption);
  return BasisPointUtil.bpToNum(price?.priceBp ?? 0);
};

export const getPlanDiscount = (billingOption: BillingOption) => {
  switch (billingOption) {
    case BillingOption.QUARTERLY:
      return 0.25;
    case BillingOption.YEAR:
      return 0.5;
    default:
      return 0;
  }
};
